import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Fieldset } from "primereact/fieldset";
import { Image } from 'primereact/image';
import Swal from "sweetalert2";
import { FileUpload } from "primereact/fileupload";

const GeneralVehicleForm = ({ formData, location, handleInputChange, parseDate, handleDateChange, options, uploadHandler, fileUploadRef, tienePermiso, puedeCambiarEstatus }) => {
    const { kardexOptions, marcaOptions, typeOptions, statusOptions, clientOptions } = options;

    const unitColors = [
        { code: 1, name: 'Blanco' },
        { code: 2, name: 'Plata' },
        { code: 3, name: 'Negro' },
    ]

    const legendTemplate = (
        <div className="flex align-items-center justify-content-between w-full">
            <div>
                <h3 className="m-0 text-lg font-semibold text-color">DATOS GENERALES DE LA UNIDAD</h3>
                <p className="m-0 mt-1 text-sm text-color-secondary">Sistema de Gestión Vehicular</p>
            </div>
        </div>
    );

    const showMap = () => {
        if (location && location?.lat && location?.lng) {
            const { lat, lng } = location;
            const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
            window.open(googleMapsUrl, '_blank');
        } else {
            Swal.fire({
                icon: "error",
                text: 'Coordenadas inválidas',
            });
        }
    };

    return (
        <Fieldset legend={legendTemplate} toggleable className="mb-3 mt-3">
            <Card className="shadow-2" style={{ background: '#F4F6F9' }}>
                {/* Header con botón de estado */}
                <div className="flex justify-content-end">
                    <Button
                        label={formData?.ACTIVA ? 'Activa' : 'Inactiva'}
                        severity={formData?.ACTIVA ? 'success' : 'info'}
                        size="small"
                        onClick={() => handleInputChange('ACTIVA', !formData?.ACTIVA)}
                        disabled={!tienePermiso}
                    />
                </div>

                <div className="p-fluid">
                    {/* Información Básica */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-info-circle text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Información Básica</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-3 lg:col-2">
                                <label className="block mb-1 text-sm font-medium text-700">No. Económico</label>
                                <InputNumber
                                    value={formData?.ID}
                                    onChange={(e) => handleInputChange('ID', e.value)}
                                    className="w-full"
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-1 text-sm font-medium text-700">Descripción</label>
                                <InputText
                                    value={formData?.DESCRIPCION}
                                    onChange={(e) => handleInputChange('DESCRIPCION', e.target.value)}
                                    className="w-full"
                                    maxLength={50}
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-1 text-sm font-medium text-700">Marca</label>
                                <Dropdown
                                    value={marcaOptions?.find(marc => marc.code === formData?.MARCA_UNIDAD)}
                                    options={marcaOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('MARCA_UNIDAD', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-1 text-sm font-medium text-700">Serie</label>
                                <InputText
                                    value={formData?.NUMERO_SERIE}
                                    onChange={(e) => handleInputChange('NUMERO_SERIE', e.target.value)}
                                    maxLength={20}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-3 lg:col-2">
                                <label className="block mb-1 text-sm font-medium text-700">Modelo</label>
                                <InputText
                                    value={formData?.MODELO}
                                    onChange={(e) => handleInputChange('MODELO', e.target.value)}
                                    maxLength={4}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Motor</label>
                                <InputText
                                    value={formData?.NUMERO_MOTOR}
                                    onChange={(e) => handleInputChange('NUMERO_MOTOR', e.target.value)}
                                    className="w-full"
                                    maxLength={30}
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Fechas y Estado */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-calendar text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Fechas y Estado</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-4 lg:col-3">
                                <label className="block mb-2 text-sm font-medium text-700">Fecha Alta</label>
                                <Calendar
                                    value={parseDate(formData?.FECHA_ALTA)}
                                    onChange={handleDateChange('FECHA_ALTA')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-3">
                                <label className="block mb-2 text-sm font-medium text-700">Fecha Baja</label>
                                <Calendar
                                    value={parseDate(formData?.FECHA_BAJA)}
                                    onChange={handleDateChange('FECHA_BAJA')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-3">
                                <label className="block mb-2 text-sm font-medium text-700">Tipo</label>
                                <Dropdown
                                    value={typeOptions?.find(option => option.code === formData?.TIPO)}
                                    options={typeOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('TIPO', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-3">
                                <label className="block mb-2 text-sm font-medium text-700">Estatus</label>
                                <Dropdown
                                    value={statusOptions?.find(status => status.code === formData?.ESTATUS)}
                                    options={statusOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('ESTATUS', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso && !puedeCambiarEstatus}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Especificaciones Técnicas */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-cog text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Especificaciones Técnicas</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-3 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Placas</label>
                                <InputText
                                    value={formData?.PLACAS}
                                    onChange={(e) => handleInputChange('PLACAS', e.target.value)}
                                    maxLength={10}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-3 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Placas Fed.</label>
                                <InputText
                                    value={formData?.PLACAS_FEDERALES}
                                    onChange={(e) => handleInputChange('PLACAS_FEDERALES', e.target.value)}
                                    maxLength={10}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-2 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Pasajeros</label>
                                <InputNumber
                                    value={formData?.PASAJEROS}
                                    onValueChange={(e) => handleInputChange('PASAJEROS', e.value)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-2 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Color</label>
                                <Dropdown
                                    value={unitColors?.find(color => color.code === formData?.COLOR)}
                                    options={unitColors}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('COLOR', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-3 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Rendimiento</label>
                                <InputNumber
                                    value={formData?.RENDIMIENTO}
                                    onValueChange={(e) => handleInputChange('RENDIMIENTO', e.value)}
                                    suffix=" km/l"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Kardex Mantenimiento</label>
                                <Dropdown
                                    value={kardexOptions?.find(kar => kar.code === formData?.MARCA)}
                                    options={kardexOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('MARCA', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Personal y Servicios */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-users text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Personal y Servicios</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Chofer</label>
                                <InputText
                                    value={formData?.CHOFER || 'Sin asignar'}
                                    readOnly
                                    className="w-full surface-100"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">GPS</label>
                                <InputText
                                    value={formData?.GPS}
                                    onChange={(e) => handleInputChange('GPS', e.target.value)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Ticket Card Número</label>
                                <InputText
                                    value={formData?.TICKETCARD_NUMERO}
                                    onChange={(e) => handleInputChange('TICKETCARD_NUMERO', e.target.value)}
                                    maxLength={12}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Ticket Card NIP</label>
                                <InputText
                                    value={formData?.TICKETCARD_NIP}
                                    onChange={(e) => handleInputChange('TICKETCARD_NIP', e.target.value)}
                                    maxLength={4}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Tarjeta IAVE</label>
                                <InputText
                                    value={formData?.TARJETA_IAVE}
                                    onChange={(e) => handleInputChange('TARJETA_IAVE', e.target.value)}
                                    maxLength={16}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-4 lg:col-2">
                                <label className="block mb-2 text-sm font-medium text-700">Cliente Fijo</label>
                                <Dropdown
                                    value={clientOptions?.find(client => client.code === formData?.ID_CLIENTE)}
                                    options={clientOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('ID_CLIENTE', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Clientes Adicionales */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-building text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Clientes Adicionales</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-6">
                                <label className="block mb-2 text-sm font-medium text-700">Cliente Combina 1</label>
                                <Dropdown
                                    value={clientOptions?.find(client => client.code === formData?.ID_CLIENTE_COMBINA_1)}
                                    options={clientOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('ID_CLIENTE_COMBINA_1', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <label className="block mb-2 text-sm font-medium text-700">Cliente Combina 2</label>
                                <Dropdown
                                    value={clientOptions?.find(client => client.code === formData?.ID_CLIENTE_COMBINA_2)}
                                    options={clientOptions}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('ID_CLIENTE_COMBINA_2', e.value.code)}
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Multimedia y Ubicación */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-image text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Multimedia y Ubicación</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-6">
                                <label className="block mb-2 text-sm font-medium text-700">Fotografía</label>
                                <div className="flex flex-column align-items-center justify-content-center surface-50 border-2 border-dashed surface-border border-round p-4" style={{ minHeight: '200px' }}>
                                    {formData?.FOTO ? (
                                        <Image
                                            src={formData?.FOTO}
                                            alt="Fotografía del vehículo"
                                            width="200"
                                            preview
                                            className="border-round mb-3"
                                        />
                                    ) : (
                                        <>
                                            <i className="pi pi-image text-6xl text-400 mb-3"></i>
                                            <p className="m-0 text-600">Sin imagen</p>
                                        </>
                                    )}
                                    <FileUpload
                                        ref={fileUploadRef}
                                        name="file"
                                        mode="basic"
                                        customUpload
                                        uploadHandler={uploadHandler}
                                        chooseLabel={formData?.FOTO ? 'Cambiar imagen' : 'Subir imagen'}
                                        accept="image/*"
                                        maxFileSize={2000000}
                                        className="mt-2"
                                        disabled={!tienePermiso}
                                    />
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <label className="block mb-2 text-sm font-medium text-700">Ubicación GPS</label>
                                <div className="flex align-items-center justify-content-center h-full">
                                    <Button
                                        label="Ver ubicación en el mapa"
                                        icon="pi pi-map-marker"
                                        outlined
                                        onClick={showMap}
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </Fieldset>
    );
};

export default GeneralVehicleForm;
